export const NAV_BAR_HEIGHT_PX = 68;

/** Approximate height of the staging TestModeBanner (py-2 + up to two lines on narrow phones). */
export const STAGING_BANNER_HEIGHT_PX = 52;
